// Landing page static data & tuning constants.

// Official KIRA logo — Knowledge · Intelligence · Research · Analysis.
// Served locally from /app/frontend/public/kira-logo.png (245KB, 512x512,
// optimized from the 1.4MB source). Local hosting eliminates the third-party
// CDN failure that previously caused broken-image icons in production.
export const LOGO_URL = "/kira-logo.png";

export const TICKER_SYMBOLS = ["NIFTY", "SENSEX", "BANKNIFTY", "INDIAVIX", "GOLD", "SILVER", "CRUDE", "USDINR"];

// Timing & layout constants
export const TICKER_REFRESH_MS = 15000; // live market ticker poll interval
export const REVEAL_THRESHOLD = 0.12;   // IntersectionObserver reveal ratio
export const SCORE_GAUGE_TOTAL = 326.7; // 2πr for r=52 in the KIRA Score gauge
export const SCORE_GAUGE_OFFSET = 80;   // dash-offset for a 75/100 fill

export const FEATURES = [
  {
    icon: "📈",
    title: "Market Watch",
    desc: "Curated educational watchlists for swing & positional study — track price structure, momentum, and sector behavior over time.",
  },
  {
    icon: "🧭",
    title: "Technical Analysis",
    desc: "Learn chart patterns, momentum signals, and breakout structure with explanations grounded in classical technical theory.",
  },
  {
    icon: "⭐",
    title: "Personal Watchlists",
    desc: "Build and save your own learning watchlists. Observe how markets move on the names you're studying.",
  },
  {
    icon: "🎯",
    title: "Entry · Target · SL (Educational)",
    desc: "Hypothetical entry, target, and stop-loss levels are shared for educational study of risk-reward structure.",
  },
  {
    icon: "💎",
    title: "Research Notes",
    desc: "Macro briefs, sector rotation notes, and earnings calendars — written for learners studying market behavior.",
  },
  {
    icon: "📊",
    title: "TradingView Charts",
    desc: "Pro-grade charts embedded inside your workspace — draw, annotate, and study technical setups in one place.",
  },
];

// Archived research studies — historical educational outcomes.
// Values below are the definitive published records (source of truth).
// `t1Hit` / `t2Hit` reflect the outcome captured at Completed Date.
export const ARCHIVED_STUDIES = [
  {
    symbol: "GENESYS",
    name: "Genesys International Corporation Ltd",
    monogram: "G",
    accent: "#4CAF50",
    publishedDate: "10 Jun 2026",
    completedDate: "19 Jun 2026",
    entry: 280.00,
    current: 337.75,
    target1: 320.00,
    target2: 350.00,
    stopLoss: 250.00,
    roi: 20.63,
    pnl: 57.75,
    status: "Completed",
    t1Hit: true,
    t2Hit: false,
  },
  {
    symbol: "SAREGAMA",
    name: "Saregama India Ltd",
    monogram: "S",
    accent: "#D4AF37",
    publishedDate: "27 May 2026",
    completedDate: "15 Jun 2026",
    entry: 380.00,
    current: 485.75,
    target1: 420.00,
    target2: 450.00,
    stopLoss: 350.00,
    roi: 27.83,
    pnl: 105.75,
    status: "Target 2 Hit",
    t1Hit: true,
    t2Hit: true,
  },
  {
    symbol: "IDEA",
    name: "Vodafone Idea Ltd",
    monogram: "V",
    accent: "#E62D2D",
    publishedDate: "27 May 2026",
    completedDate: "27 May 2026",
    entry: 10.00,
    current: 14.25,
    target1: 12.00,
    target2: 14.00,
    stopLoss: 8.00,
    roi: 42.50,
    pnl: 4.25,
    status: "Target 2 Hit",
    t1Hit: true,
    t2Hit: true,
  },
  {
    symbol: "TIMEX",
    name: "Timex Group India Ltd",
    monogram: "T",
    accent: "#7C4DFF",
    publishedDate: "27 May 2026",
    completedDate: "25 Jun 2026",
    entry: 420.00,
    current: 524.45,
    target1: 440.00,
    target2: 460.00,
    stopLoss: 400.00,
    roi: 24.87,
    pnl: 104.45,
    status: "Target 2 Hit",
    t1Hit: true,
    t2Hit: true,
  },
];

export const ARCHIVED_STATS = [
  { icon: "📁", label: "Research Studies", value: "18+" },
  { icon: "🏆", label: "Successful Outcomes", value: "14" },
  { icon: "📈", label: "Average Historical Return", value: "21.8%" },
  { icon: "🏢", label: "Stocks Covered", value: "35+" },
];

export const TEAM = [
  {
    name: "Sabarinadh Palutla",
    role: "Founder & CEO",
    bio: "Visionary behind KIRA Markets, focused on building an institutional-quality educational research platform for retail investors.",
    initials: "SP",
    accent: "linear-gradient(135deg, #D4AF37 0%, #F2C94C 100%)",
  },
  {
    name: "Rajnish Raj",
    role: "VP & Co-Founder",
    bio: "Leading product development, research operations and platform innovation while helping shape the long-term vision of KIRA.",
    initials: "RR",
    accent: "linear-gradient(135deg, #C0C0C0 0%, #EAEAEA 100%)",
  },
];

export const TESTIMONIALS = [
  {
    name: "Arjun Mehta",
    role: "Market Learner · Mumbai",
    text:
      "KIRA Markets made technical structure click for me. The watchlists are excellent study material for anyone learning swing setups.",
  },
  {
    name: "Priya Raman",
    role: "Trader · Bengaluru",
    text:
      "A clean research workspace at last. The market watch panel and notes section have become part of my daily study routine.",
  },
  {
    name: "Vikram Shah",
    role: "Technical Analyst",
    text:
      "Their educational analytics on price structure and momentum are some of the most well-explained on the Indian markets right now.",
  },
];
